import { GridLayout } from '@wishket/design-system';
import { twJoin } from 'tailwind-merge';
import { ReactNode } from 'react';

interface AskAIGridLayoutProps {
  children: ReactNode;
  isShareRoute?: boolean;
}

const AskAIGridLayout = ({
  children,
  isShareRoute = false,
}: AskAIGridLayoutProps) => {
  return (
    <GridLayout
      gridTemplateAreaClass={twJoin(
        'gap-4 desktop:gap-10 tablet:grid-areas-askAI-tablet grid-areas-askAI-mobile p-0',
        isShareRoute
          ? 'desktop:grid-areas-askAI-desktop-share px-5 desktop:px-0'
          : 'desktop:grid-areas-askAI-desktop'
      )}
    >
      {children}
    </GridLayout>
  );
};

export default AskAIGridLayout;
